var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCountGuestsVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 176.67,
    height: 195.137,
    viewBox: "0 0 176.67 195.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#bce0fd;}.b{fill:#f6d2bf;}.c{fill:#013272;}.d{fill:#013b88;}.e{fill:#00429a;}.f{fill:#0075eb;}.g{fill:#f0c3ab;}.h{fill:#1a8cff;}.i{fill:#f7ded0;}.j{fill:#fc6fd0;}.k{fill:#fc98dd;}.l{fill:#385cf8;}.m{fill:#fff;}.n{filter:url(#c);}.o{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 95.699,
    y: 114.166,
    width: 80.971,
    height: 80.971,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 111.708,
    y: 134.175,
    width: 49.445,
    height: 42.514,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-555.302 -230.387)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(575.078 250.13)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,83.461A83.461,83.461,0,1,0,83.461,0,83.471,83.471,0,0,0,0,83.461Z",
    transform: "translate(-19.33 -19.742)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.009 14.179)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M128.656,335.08l-1.909,18.12a12.3,12.3,0,0,1-6.276,9.638l-17.508,9.726a9.185,9.185,0,0,1-6.261.935h0s8.827-2.675,14.08-16.9c1.609-4.356,3.843-27.417,1.922-30.235-3.8-5.57-24.984-6.15-31.243-16.484q.464-.576.855-1.152c.021-.031.046-.062.068-.094a11.848,11.848,0,0,0,.725-1.23C98.483,322.782,128.656,310.482,128.656,335.08Z",
    transform: "translate(-46.209 -279.734)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M70.762,260.879c13.389.751,34.259,3.2,42.064,20.076,2.549,5.5,6.724,21.535,5.734,39.31s-16.913,39.961-16.913,39.961-6.6,5.891-7.983,6.727C88.27,370.2,88.229,377.6,67.626,377.6L55.326,291.5",
    transform: "translate(-26.825 -260.757)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M127.183,260.673c5.7,0,16.312,4.357,16.312,4.357a105.608,105.608,0,0,1,6.955,12.979,44.543,44.543,0,0,1,3.079,10.922c-15.951-2.691-22.5,9.216-38.646,2.49l12.3,86.095a80.67,80.67,0,0,1-40.808-10.852,4.58,4.58,0,0,1-2.244-3.917C83.909,319.858,78.513,260.673,127.183,260.673Z",
    transform: "translate(-74.909 -260.673)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M161.14,365.047c-.191-36.853-4.169-85.7,25.587-98.732.519,2.7,1.459,10.222-.984,15.108-6.15,12.3-12.3,12.3-18.45,21.523-6.15,33.823,11.75,69.721,17.7,74.608h0a77.355,77.355,0,0,1-21.6-8.59A4.582,4.582,0,0,1,161.14,365.047Z",
    transform: "translate(-151.917 -262.974)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M63.854,431.906l27.438-11.432a6.149,6.149,0,0,0,3.785-5.677v-7.43h30.749v7.43a6.149,6.149,0,0,0,3.785,5.677h0c.433.181-4.9,1.21-3.2,2.027,6.613,3.175-2.214,1.657-2.214,4.912l-6.436,7.139c0,2.887-12.191,4.792-15.078,4.792L63.4,453.644a5.228,5.228,0,0,1-5.228-5.228v-7.995A9.226,9.226,0,0,1,63.854,431.906Z",
    transform: "translate(-58.176 -320.505)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M63.562,441.472l26.529-11.054,20.068,8.661,20.068-8.661h0a21.029,21.029,0,0,1-4.057,7.043A55.5,55.5,0,0,1,118,444.706a75.53,75.53,0,0,1-16.469,10.357c-9.486,4.3-13.924,5.521-21.475,6.828a119.029,119.029,0,0,1-16.942,1.316,5.228,5.228,0,0,1-5.228-5.227v-7.995A9.225,9.225,0,0,1,63.562,441.472Z",
    transform: "translate(-57.885 -330.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M94.691,407.367H125.44V414.8a6.149,6.149,0,0,0,3.785,5.676l-1.556,1.476C94.876,430.311,94.691,407.367,94.691,407.367Z",
    transform: "translate(-57.791 -320.505)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001 95.317)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M189.535,466.776v-7.995a9.2,9.2,0,0,1,2.6-6.4l12.382,9.779a9.224,9.224,0,0,1,3.462,7.2v1.716s-.156.206-3.462.436-9.76.485-9.76.485A5.227,5.227,0,0,1,189.535,466.776Z",
    transform: "translate(-189.535 -434.183)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M130.7,456c1.538-.979,2.672-1.874,2.672-1.874V444.78h-6.15v13.26S129.161,456.977,130.7,456Z",
    transform: "translate(-78.022 -431.083)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M91.981,435.337l17.6-13.2a2.459,2.459,0,0,1,3.523.6l.911,3.768s-.2.192-2.111,2.637c-.214.26-2.323,2.762-2.323,2.762l-3.874,4.405-6.3,4.9Z",
    transform: "translate(-39.707 -421.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M157.014,435.337l-17.6-13.2a2.459,2.459,0,0,0-3.523.6l-3.478,5.216,10.79,15.106a2.461,2.461,0,0,0,3.538.491Z",
    transform: "translate(-104.74 -421.647)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M96.713,307.407c15.375,15.373,45.548,3.075,45.548,27.673l-1.909,18.12a12.3,12.3,0,0,1-6.276,9.638l-17.508,9.726a9.224,9.224,0,0,1-8.959,0L90.1,362.838a12.3,12.3,0,0,1-6.276-9.638l-2.2-21.519a33.945,33.945,0,0,1-.139-4.6C82.632,319.249,93.638,313.557,96.713,307.407Z",
    transform: "translate(-59.813 -279.735)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M128.656,335.08l-1.909,18.12a12.3,12.3,0,0,1-6.276,9.638l-17.508,9.726a9.185,9.185,0,0,1-6.261.935h0s8.827-2.675,14.08-16.9c1.609-4.356,3.843-27.417,1.922-30.235-3.8-5.57-24.984-6.15-31.243-16.484q.464-.576.855-1.152c.021-.031.046-.062.068-.094a11.848,11.848,0,0,0,.725-1.23C98.483,322.782,128.656,310.482,128.656,335.08Z",
    transform: "translate(-46.209 -279.733)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.776 14.179)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M81.461,335.08,83.37,353.2a12.3,12.3,0,0,0,6.276,9.638l17.508,9.726a9.184,9.184,0,0,0,6.261.935h0s-8.827-2.675-14.08-16.9c-1.609-4.356-3.843-27.417-1.922-30.235,3.8-5.57,24.983-6.15,31.243-16.485q-.464-.576-.855-1.152c-.021-.031-.046-.062-.068-.094a11.847,11.847,0,0,1-.725-1.23C111.633,322.782,81.461,310.482,81.461,335.08Z",
    transform: "translate(-72.024 -279.734)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M103.272,260.879c-13.389.751-34.258,3.2-42.063,20.076-2.549,5.5-6.724,21.535-5.734,39.31s16.913,39.961,16.913,39.961,6.6,5.891,7.983,6.728c5.393,3.251,5.435,10.645,26.037,10.645l12.3-86.094",
    transform: "translate(-55.326 -260.757)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M110.2,260.673c-5.7,0-16.312,4.357-16.312,4.357a105.612,105.612,0,0,0-6.955,12.979A44.543,44.543,0,0,0,83.85,288.93c15.951-2.691,22.5,9.216,38.646,2.49l-12.3,86.1A80.669,80.669,0,0,0,151,366.663a4.58,4.58,0,0,0,2.244-3.917C153.47,319.858,158.867,260.673,110.2,260.673Z",
    transform: "translate(-70.587 -260.673)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M187.069,365.048c.191-36.854,4.169-85.7-25.586-98.733-.519,2.7-1.459,10.223.984,15.108,6.15,12.3,12.3,12.3,18.449,21.524,6.15,33.823-11.75,69.721-17.7,74.608h0a77.353,77.353,0,0,0,21.6-8.591A4.582,4.582,0,0,0,187.069,365.048Z",
    transform: "translate(-104.408 -262.974)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M123.957,431.907,96.519,420.475a6.15,6.15,0,0,1-3.785-5.677v-7.43H61.986v7.43a6.149,6.149,0,0,1-3.784,5.677h0c-.433.181,4.9,1.21,3.2,2.027-6.613,3.175,2.214,1.657,2.214,4.912l6.436,7.139c0,2.887,12.191,4.792,15.078,4.792l39.277,14.3c2.887,0-.45-.275-.45-3.162v-7.023s.018-2.474,0-3.038C123.969,437.262,127.391,433.338,123.957,431.907Z",
    transform: "translate(-37.751 -320.505)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M124.549,441.472,98.02,430.418l-20.068,8.661-20.068-8.661h0a21.03,21.03,0,0,0,4.057,7.043,55.5,55.5,0,0,0,8.172,7.245,75.527,75.527,0,0,0,16.469,10.357c9.486,4.3,13.924,5.521,21.474,6.828A119.027,119.027,0,0,0,125,463.209c2.887,0-.45,1.57-.45-1.316l.45-10.625C125,447.543,127.986,442.9,124.549,441.472Z",
    transform: "translate(-38.343 -330.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M129.224,407.367H98.476V414.8a6.149,6.149,0,0,1-3.785,5.676l1.556,1.476C129.04,430.311,129.224,407.367,129.224,407.367Z",
    transform: "translate(-74.241 -320.504)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.576 95.318)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M201.887,467.607v-7.751c0-2.44,1.63-4.974,0-6.661L193,461.355a9.224,9.224,0,0,0-3.462,7.2v1.716s.156.206,3.462.436,9.76.485,9.76.485C205.643,471.2,201.887,470.493,201.887,467.607Z",
    transform: "translate(-133.677 -433.376)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M129.893,456c-1.538-.979-2.672-1.874-2.672-1.874V444.78h6.15v13.26S131.431,456.977,129.893,456Z",
    transform: "translate(-108.263 -431.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M114.014,435.337l-17.6-13.2a2.459,2.459,0,0,0-3.523.6l-.911,3.768s.2.192,2.111,2.637c.214.26,2.323,2.762,2.323,2.762l3.874,4.406,6.3,4.9Z",
    transform: "translate(-91.981 -421.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M132.414,435.337l17.6-13.2a2.459,2.459,0,0,1,3.523.6l3.478,5.216-10.79,15.106a2.461,2.461,0,0,1-3.538.491Z",
    transform: "translate(-110.381 -421.647)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M127.007,307.407C111.633,322.78,81.46,310.482,81.46,335.08l1.909,18.12a12.3,12.3,0,0,0,6.276,9.638l17.508,9.726a9.224,9.224,0,0,0,8.959,0l17.508-9.726A12.3,12.3,0,0,0,139.9,353.2l2.2-21.52a33.944,33.944,0,0,0,.139-4.6C141.088,319.249,130.082,313.557,127.007,307.407Z",
    transform: "translate(-72.024 -279.734)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M81.461,335.08,83.37,353.2a12.3,12.3,0,0,0,6.276,9.638l17.508,9.726a9.184,9.184,0,0,0,6.261.935h0s-8.827-2.675-14.08-16.9c-1.609-4.356-3.843-27.417-1.922-30.235,3.8-5.57,24.983-6.15,31.243-16.485q-.464-.576-.855-1.152c-.021-.031-.046-.062-.068-.094a11.847,11.847,0,0,1-.725-1.23C111.633,322.782,81.461,310.482,81.461,335.08Z",
    transform: "translate(-72.024 -279.733)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M.16,10.224l166.415-.065a26.5,26.5,0,0,0,.561-5.049A27.53,27.53,0,0,0,166.575,0L.16.139S0,2.557,0,5.078.16,10.224.16,10.224Z",
    transform: "translate(69.195 -19.705) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(660.001 350.554)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "o",
    transform: "matrix(1, 0, 0, 1, -104.7, -120.17)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 31.485,
    cy: 31.485,
    r: 31.485,
    transform: "translate(104.7 120.17)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "n",
    transform: "matrix(1, 0, 0, 1, -104.7, -120.17)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M10.271,23.72.783,14.007a2.884,2.884,0,0,1,0-3.951l2.166-2.2a2.778,2.778,0,0,1,3.886,0l5.364,5.5L24.607.8a2.756,2.756,0,0,1,3.886,0L30.659,3a2.865,2.865,0,0,1,0,3.943L16.614,21.161a2.449,2.449,0,0,1-.3.36l-2.158,2.2a2.773,2.773,0,0,1-3.886,0Z",
    transform: "translate(120.71 140.18)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountGuestsVerified);
export default __webpack_public_path__ + "static/media/count-guests-verified.8ed1116adca309bf0dfd125cab94931b.svg";
export { ForwardRef as ReactComponent };